<div class="service-details-container">
  <div class="breadcrumb-header">
    <div class="breadcrumb">
      <span class="text-muted" routerLink="/company-admin/billing-payments">{{ 'dash.billingTitle' | translate }}</span>
      <i class="bi bi-chevron-right mx-2 text-muted" style="font-size: 12px;"></i>
      <span>{{ 'dash.virtualInterview' | translate }}</span>
    </div>
    <button class="btn-back" routerLink="/company-admin/billing-payments">
      <i class="bi bi-arrow-left"></i> {{ 'dash.backToBillingShort' | translate }}
    </button>
  </div>

  <div class="page-title">
    <h1>{{ 'dash.virtualInterview' | translate }} <span class="badge active-badge">{{ 'dash.active' | translate }}</span></h1>
    <p class="subtitle">{{ 'dash.currentPackageGrowth' | translate }}</p>
  </div>

  <div class="main-layout">
    <!-- Main Package Card -->
    <div class="card package-card">
      <div class="card-header-flex">
        <div>
          <p class="label">{{ 'dash.currentPackage' | translate }}</p>
          <h2>{{ 'dash.growthPlan' | translate }}</h2>
          <p class="sub-text">{{ 'dash.interviewsCount' | translate:{ count: 100 } }}</p>
        </div>
        <div class="stats-right">
          <div class="stat-box">
            <span class="stat-num">37</span>
            <span class="stat-label">{{ 'dash.used' | translate }}</span>
          </div>
          <div class="stat-box">
            <span class="stat-num red-text">63</span>
            <span class="stat-label">{{ 'dash.remaining' | translate }}</span>
          </div>
        </div>
      </div>

      <div class="progress-section">
        <div class="progress-labels">
          <span>{{ 'dash.interviewsUsed' | translate:{ used: 37, total: 100 } }}</span>
          <span class="remaining red-text">{{ 'dash.remainingCount' | translate:{ count: 63 } }}</span>
        </div>
        <div class="progress-bar-container">
          <div class="progress-bar" style="width: 37%"></div>
        </div>
        <span class="used-text">{{ 'dash.percentUsed' | translate:{ percent: 37 } }}</span>
      </div>

      <div class="divider"></div>

      <div class="details-grid">
        <div>
          <p class="label">{{ 'dash.purchaseDate' | translate }}</p>
          <p class="value">25 Jul 2026</p>
        </div>
        <div>
          <p class="label">{{ 'dash.amountPaid' | translate }}</p>
          <p class="value">EGP 10,500</p>
        </div>
      </div>

      <div class="actions mt-4">
        <button class="btn-gradient" routerLink="/company-admin/billing-virtual-purchase">{{ 'dash.upgradePackage' | translate }}</button>
        <button class="btn-outline">{{ 'dash.renewPackage' | translate }}</button>
      </div>
    </div>

    <!-- Usage Overview Card -->
    <div class="card usage-card">
      <h3 class="card-title">{{ 'dash.usageOverview' | translate }}</h3>
      
      <div class="usage-list">
        <div class="usage-item">
          <span class="usage-label">{{ 'dash.totalPurchased' | translate }}</span>
          <span class="usage-value">100</span>
        </div>
        <div class="usage-item">
          <span class="usage-label">{{ 'dash.used' | translate }}</span>
          <span class="usage-value">37</span>
        </div>
        <div class="usage-item">
          <span class="usage-label">{{ 'dash.remaining' | translate }}</span>
          <span class="usage-value red-text">63</span>
        </div>
      </div>

      <p class="usage-info-text mt-4">
        {{ 'dash.usageInterviews' | translate }}
      </p>
    </div>

    <!-- Purchase Details Card -->
    <div class="card">
      <h3 class="card-title">{{ 'dash.purchaseDetails' | translate }}</h3>
      
      <div class="purchase-info">
        <div class="info-row">
          <span class="info-label">{{ 'dash.reference' | translate }}</span>
          <span class="info-value">UPC-INT-20260725-0412</span>
        </div>
        <div class="info-row">
          <span class="info-label">{{ 'dash.purchaseDate' | translate }}</span>
          <span class="info-value">25 Jul 2026</span>
        </div>
        <div class="info-row">
          <span class="info-label">{{ 'dash.amountPaid' | translate }}</span>
          <span class="info-value">EGP 10,500</span>
        </div>
        <div class="info-row">
          <span class="info-label">{{ 'dash.paymentStatus' | translate }}</span>
          <span class="badge active-badge">{{ 'dash.paid' | translate }}</span>
        </div>
      </div>

      <button class="btn-outline-gray mt-4">
        <i class="bi bi-file-earmark-text"></i> {{ 'dash.viewInvoice' | translate }}
      </button>
    </div>

    <!-- Recent Activity Card -->
    <div class="card">
      <div class="card-header-flex">
        <h3 class="card-title m-0">{{ 'dash.recentActivityShort' | translate }}</h3>
        <a href="#" class="view-all">{{ 'dash.viewBillingHistory' | translate }}</a>
      </div>
      
      <div class="activity-list mt-4">
        <div class="activity-item">
          <div class="activity-left">
            <h4>{{ 'dash.growthPlan' | translate }}</h4>
            <p>25 Jul 2026</p>
          </div>
          <div class="activity-right">
            <span class="amount">EGP 10,500</span>
            <span class="badge active-badge">{{ 'dash.paid' | translate }}</span>
          </div>
        </div>
        <div class="activity-divider"></div>
        
        <div class="activity-item">
          <div class="activity-left">
            <h4>{{ 'dash.starter' | translate }}</h4>
            <p>28 Jun 2026</p>
          </div>
          <div class="activity-right">
            <span class="amount">EGP 6,000</span>
            <span class="badge active-badge">{{ 'dash.paid' | translate }}</span>
          </div>
        </div>
        <div class="activity-divider"></div>
        
        <div class="activity-item">
          <div class="activity-left">
            <h4>{{ 'dash.starter' | translate }}</h4>
            <p>30 May 2026</p>
          </div>
          <div class="activity-right">
            <span class="amount">EGP 6,000</span>
            <span class="badge active-badge">{{ 'dash.paid' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
